import React from "react";

function About() {
  return (
    <section className="about">
      <h2>About Us</h2>
      <h3>Bridging Global Demand with Sri Lankan Excellence</h3>
      <p>
        SimpliConnect was founded to bridge the gap between global demand and
        Sri Lankan excellence. We don't just provide resources; we build the
        infrastructure—handling recruitment, legal compliance, and payroll so
        you can focus on growing your business.
      </p>
    </section>
  );
}

export default About;